import {z} from 'zod';
import {toast} from 'react-toastify';
import React, {FC, useState} from 'react';
import {zodResolver} from '@hookform/resolvers/zod';
import {FormProvider, useForm} from 'react-hook-form';
import {VerdocsButton, VerdocsSpinner} from '@verdocs/web-sdk-react';
import {createOrganization, VerdocsEndpoint} from '@verdocs/js-sdk';
import {TextInput} from '../Components';
import {AppState} from '../AppState';
import {Dialog} from './Dialog';

const schema = z.object({
  name: z.string().trim().min(1, 'Name is required'),
});

type SchemaType = z.infer<typeof schema>;

interface AddChildDialogProps {
  onClose?: () => void;
}

export const CreateChildDialog: FC<AddChildDialogProps> = ({onClose = () => {}}) => {
  const organizationId = AppState.currentProfile?.organization_id || '';
  const [submitting, setSubmitting] = useState(false);

  const form = useForm<SchemaType>({
    mode: 'all',
    resolver: zodResolver(schema),
    defaultValues: {name: ''},
  });

  const onSubmit = (data: {name: string}) => {
    setSubmitting(true);
    return createOrganization(VerdocsEndpoint.getDefault(), {name: data.name, parent_id: organizationId} as any)
      .then((r) => {
        console.log('r', r);
        setSubmitting(false);
        form.reset();
        toast.success('Child organization created!');
        onClose();
      })
      .catch((e) => {
        console.log('e', e);
        setSubmitting(false);
        toast.error(`Unable to create child organization: ${e.response?.data?.error || e.message}`);
      });
  };

  return (
    <Dialog onCancel={onClose}>
      <h1 className="sans-serif font-bold text-xl text-[#33364b] mb-2">Create Child Organization</h1>
      <p className="text-sm text-gray-500 mb-4">The new organization will be created as a child of your current organization.</p>
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <TextInput label="Organization Name" name="name" required />

          <div className="flex flex-row items-center justify-end mt-10 gap-4">
            <VerdocsButton size="small" variant="outline" label="Cancel" onClick={onClose} disabled={submitting} />
            <VerdocsButton size="small" label="Create" type="submit" disabled={submitting} />
            {submitting && <VerdocsSpinner mode="dark" />}
          </div>
        </form>
      </FormProvider>
    </Dialog>
  );
};
